import React, { forwardRef } from 'react';
import investoroLogo from 'assets/icons/investoro_pdf_logo.png';
import dayjs from 'dayjs';
import styled from 'styled-components';

export const PdfWrapperV2 = styled.div`
    background-color: #ffffff;
    position: absolute;
    top: 0;
    left: 100vw;
    width: 1000px;

    .accordion-card-content {
        grid-template-columns: 1fr 1fr !important;
    }
`;

const FooterWrapper = styled.div`
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 30px;
`;

const FooterLeft = styled.p`
    font-size: 11px;
    color: var(--color-primary-70);
    font-weight: 500;
`;

const FooterRight = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const FooterLogo = styled.img`
    height: 22px;
    width: auto;
`;

const FooterDate = styled.p`
    font-size: 11px;
    color: var(--color-primary-70);
    font-weight: 500;
`;

export const ValuationPdfFooter = forwardRef<HTMLDivElement>((_, ref) => <FooterWrapper ref={ref}>
    <FooterLeft>www.investoro.pl</FooterLeft>
    <FooterRight>
        <FooterLogo src={investoroLogo} alt="Investoro logo" />
        <FooterDate>{dayjs(new Date()).format('DD.MM.YYYY')}</FooterDate>
    </FooterRight>
</FooterWrapper>);
